import React from 'react';
import Tabs from './Tabs';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';

interface PropsType {
    className?: string;
    namespace: string;
    parameter?: string;
    children: React.ReactNode;
    tabsPlacement?: string;
    onChange?: (value: string | null) => void;
    onClose?: (key: string) => void;
    allowNoActive?: boolean;
    allowClose?: boolean;
}

const RoutedTabs = observer('RoutedTabs', (props: PropsType) => {
    const appState = useAppStateContext();
    const { className, tabsPlacement, onClose, allowNoActive, allowClose } = props;

    const getActiveTab = (): string | number | null => {
        const { namespace, parameter } = props;

        if (parameter === undefined) {
            console.info('ROUTED RoutedTabs get 2');
            // Get value of specified route namespace
            return appState.routerBackoffice.getValueString(namespace);
        } else {
            console.info('ROUTED RoutedTabs get 1 (1)');
            // Get only parameter of specified route namespace
            return appState.routerBackoffice.getParameter(namespace, parameter);
        }
    };

    const setActiveTab = (tab: string | number | null): void => {
        const { namespace, parameter, onChange } = props;

        if (parameter === undefined) {
            console.info('ROUTED RoutedTabs set 2');
            appState.routerBackoffice.redirectToNamespace(`${namespace}:${tab}`, {});
        } else {
            console.info('ROUTED RoutedTabs set 1 (1)');
            // // Set only parameter of specified route namespace
            appState.routerBackoffice.setParamInNamespace(namespace, parameter, tab);
        }

        if (onChange !== undefined) {
            if (typeof tab === 'number') {
                console.error('RoutedTabs -> onChange -> string or number was expected', tab);
            } else {
                onChange(tab);
            }
        }
    };

    return (
        <Tabs
            className={className}
            tabsPlacement={tabsPlacement}
            active={getActiveTab()}
            onChange={setActiveTab}
            //@ts-expect-error
            onClose={onClose}
            allowNoActive={allowNoActive}
            allowClose={allowClose}
        >
            {props.children}
        </Tabs>
    );
});

// eslint-disable-next-line import/no-default-export
export default RoutedTabs;
